import { preloadable, type Preloadable } from '@/lib/preloadable';

/** Jeder Blogartikel ist ein eigener Chunk und wird erst beim Aufruf geladen. */
export const ARTIKEL: Record<string, Preloadable<object>> = {
  'ki-entwickler-gehalt-karriere-deutschland-2025': preloadable(() => import('./KiEntwicklerGehalt')),
  'cybersecurity-gehalt-it-security-jobs-deutschland': preloadable(() => import('./CybersecurityGehalt')),
  'cloud-computing-jobs-gehalt-aws-azure-karriere': preloadable(() => import('./CloudComputingKarriere')),
  'remote-work-digital-transformation-it-jobs': preloadable(() => import('./RemoteWorkDigitalTransformation')),
  'aiops-2026': preloadable(() => import('./aiops-2026')),
  'machine-learning-python': preloadable(() => import('./ml-python-2026')),
  'eu-ai-act-rollen-recruiting-2026': preloadable(() => import('./AiActRollen2026')),
  'cloud-architect-gehalt-2026': preloadable(() => import('./CloudArchitectGehalt')),
  'it-fachkraeftemangel-2026-berlin': preloadable(() => import('./Fachkraeftemangel2026')),
  'soc-analyst-gehalt-2026': preloadable(() => import('./SocAnalystGehalt')),
  'cloud-engineer-gehalt-2026': preloadable(() => import('./CloudEngineerGehalt')),
  'softwareentwickler-arbeitsmarkt-berlin-2026': preloadable(() => import('./SoftwareentwicklerBerlin2026')),
  'gehaltstransparenz-softwareentwickler-2026': preloadable(() => import('./Gehaltstransparenz2026')),
  'digitale-souveraenitaet-open-source-fachkraefte-2026': preloadable(() => import('./DigitaleSouveraenitaet2026')),
  'ki-jobs-deutschland-anwender-entwickler-2026': preloadable(() => import('./KiJobsDeutschland2026')),
  '80000-euro-gehalt-it-realistisch': preloadable(() => import('./Gehalt80000It')),
  'neue-mitarbeiter-verdienen-mehr-als-langjaehrige': preloadable(() => import('./NeueMitarbeiterVerdienenMehr')),
};

export const preloadArtikel = (slug: string) => ARTIKEL[slug]?.preload() ?? Promise.resolve();
export const preloadAlleArtikel = () => Promise.all(Object.values(ARTIKEL).map((a) => a.preload()));
